import { Box, CardMedia, Modal, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import AdxInput from 'components/custom/AdxInput'
import AdxButton from 'components/custom/AdxButton'

const ApproveAndReasonModal = ({
  handleToggle,
  handleUpdate,
  isLoading,
  open,
  setReason,
  type,
}) => {
  //   const [talentDetails, setTalentDetails] = useState({
  //     email,
  //   })

  //   const handleToggle = () => {
  //     setOpen((prevOpen) => !prevOpen)
  //   }

  //   const handleUpdate = () => {
  //     const updatedData = {
  //       ...(talentDetails.email !== email ? { email: talentDetails.email } : {}),
  //     }
  //     editDetails(updatedData)
  //   }

  return (
    <React.Fragment>
      <Modal
        open={open}
        onClose={handleToggle}
        sx={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            backgroundColor: 'white.main',
            borderRadius: '6.5px',
            maxWidth: '650px',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingX: '24px',
              paddingY: '15px',
              borderBottom: '1px solid #E5E5E5',
            }}
          >
            <Typography>{type} Request</Typography>
            <CloseIcon onClick={handleToggle} sx={{ cursor: 'pointer' }} />
          </Box>
          <Box sx={{ padding: '24px', display: 'flex', flexDirection: 'column', gap: '24px' }}>
            <Typography>Are you sure you want to approve this?</Typography>

            <AdxInput
              label="Reason (if any)"
              sxSubLabel={{ color: 'red' }}
              size="standard"
              //   defaultValue={candidateEmail}
              onChange={(e) => setReason(e.target.value)}
            />
          </Box>
          <Box
            sx={{
              paddingX: '24px',
              paddingTop: '20px',
              paddingBottom: '30px',
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '10px',
              borderTop: '1px solid #E5E5E5',
            }}
          >
            <AdxButton variant={'outlined'} onClick={handleToggle} sx={{ width: '100px' }}>
              Cancel
            </AdxButton>
            {type === 'Approve' && (
              <AdxButton
                variant={'contained'}
                isLoading={isLoading}
                onClick={handleUpdate}
                sx={{ width: '200px' }}
              >
                Approve Request
              </AdxButton>
            )}
            {type === 'Reject' && (
              <AdxButton
                variant={'contained'}
                isLoading={isLoading}
                onClick={handleUpdate}
                sx={{ width: '200px' }}
                color="error"
                hoverBackgroundColor="light-error"
              >
                Reject request
              </AdxButton>
            )}
          </Box>
        </Box>
      </Modal>
    </React.Fragment>
  )
}

export default ApproveAndReasonModal
